import { Action } from "redux";

export const ARIA_LIVE_ANNOUNCE = "ariaLiveAnnounce";

export interface AriaLiveAnnounceAction extends Action {
  type: typeof ARIA_LIVE_ANNOUNCE;
  message: string;
}

const makeAnnouncement = (message: string): AriaLiveAnnounceAction => {
  return { type: ARIA_LIVE_ANNOUNCE, message };
};

let timeoutId;
export const ariaLiveAnnounce = (message: string) => {
  return function (dispatch) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    dispatch(makeAnnouncement(message));
    timeoutId = setTimeout(() => {
      // it is good practice to clear the aria live region after a short while
      dispatch(makeAnnouncement(""));
    }, 3000);
  };
};

export type AriaLiveAction = AriaLiveAnnounceAction;
